/* eslint-disable @calm/react-intl/missing-formatted-message */
'use client';

import { useEffect } from 'react';

import { calmLogger } from '@/utils/calmLogger';

interface ErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export default function AppRouterError({ error, reset }: ErrorProps) {
	useEffect(() => {
		// Log the error for debugging
		calmLogger.error('App Router error caught', {}, error);

		// Redirect to Pages Router error handling to maintain consistency
		// Use location.replace to avoid adding to history stack
		window.location.replace('/_error');
	}, [error]);

	// Fallback UI in case redirect doesn't work immediately
	return (
		<div>
			<h2>Something went wrong!</h2>
			<p>Redirecting to error page...</p>
		</div>
	);
}
